import { useEffect } from 'react';
import { useAuth } from 'hooks';

// The admin panel opens /impersonate#token=<impersonation token> (as it does
// for TO): it cannot write this app's localStorage from its own origin.
export default function Impersonate() {
  const { onUpdate, setImpersonationToken } = useAuth();

  useEffect(() => {
    const token = new URLSearchParams(window.location.hash.slice(1)).get(
      'token',
    );

    if (token) {
      const realAccessToken = localStorage.getItem('accessToken');
      const refreshToken = localStorage.getItem('refreshToken');
      // Without a session of its own, the stored access token is the previous
      // impersonation's: the new one replaces both, never becomes the "own" one.
      const ownSession =
        !!realAccessToken &&
        realAccessToken !== localStorage.getItem('impersonationToken');

      localStorage.clear();
      if (realAccessToken) localStorage.setItem('accessToken', realAccessToken);
      if (refreshToken) localStorage.setItem('refreshToken', refreshToken);

      // No session of its own here: stopping the impersonation logs out.
      if (!ownSession) onUpdate({ accessToken: token, refreshToken: '' });
      setImpersonationToken(token);
    }
    // replace() keeps the token out of the browser history.
    window.location.replace('/');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
